import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { ModalSize } from '../../modal-sizes';
import { GspImageCropperService } from './gsp-image-cropper.service';

@Component({
    selector: 'gsp-image-cropper',
    templateUrl: './gsp-image-cropper.component.html'
})
export class GspImageCropperComponent implements OnInit, AfterViewInit {
    public ModalSize = ModalSize;

    imageChangedEvent: Event = null;
    croppedImageUrl = '';
    defaultWidth = 265;
    defaultHeight = 125;
    noErrorsFound = true;

    @Input() aspectRatio = this.defaultWidth / this.defaultHeight;
    @Input() resizeToWidth = this.defaultWidth;
    @Input() resizeToHeight = this.defaultHeight;
    @Output() croppedImageEvent = new EventEmitter<any>();

    @ViewChild('fileInput') fileInput: ElementRef;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private imageCropperService: GspImageCropperService
    ) {}

    ngOnInit(): void {
        if (!this.route?.snapshot.queryParams) {
            this.closeCropper();
        }
    }

    ngAfterViewInit(): void {
        this.fileInput.nativeElement.click();
    }

    public fileChangeEvent(event: Event): void {
        this.imageChangedEvent = event;
        this.noErrorsFound = true;
    }

    public imageCropped(imageCroppedEvent: ImageCroppedEvent): ImageCroppedEvent {
        this.clearImage();
        this.imageCropperService.imageCroppedEvent$.next(imageCroppedEvent);
        return !imageCroppedEvent ? null : imageCroppedEvent;
    }

    public loadImageFailed(): void {
        this.clearImage();
        this.noErrorsFound = false;
    }

    public selectCroppedImage(): void {
        this.redirectToPreviousModal();
    }

    // modal closure
    public closeCropper(): void {
        this.clearImage();
        this.redirectToPreviousModal();
    }

    private clearImage(): void {
        this.imageCropperService.clearCroppedImageCache();
    }

    private redirectToPreviousModal(mode: string = 'workspace/details'): void {
        const prevWorkspaceParams = this.route.snapshot.queryParams;

        this.router.navigate(['mapViewer', { outlets: { centerDialog: mode } }], {
            queryParamsHandling: 'preserve',
            queryParams: { prevWorkspaceParams }
        });
    }
}
